// champisDisplayName is registered globally on the User model by
// champis-users' own extend.js (`new Extend.Model(User).attribute(
// 'champisDisplayName')`), not this extension - so this only works while
// that extension is active, same implicit (schema-level, not
// composer-level) coupling as the PHP side (see
// extensions/champis-species/src/AuthorDisplayNameResolver.php, which
// mirrors this same "Prénom Nom" > pseudo > username rule server-side).

/**
 * "Prénom Nom" > pseudo > username, already computed server-side as
 * `champisDisplayName` - same rule as AuthorDisplayNameResolver on the PHP
 * side, kept in sync by hand since that one also runs against contexts
 * outside of an API response.
 */
export default function authorDisplayName(user) {
  if (!user) return null;
  return user.champisDisplayName && user.champisDisplayName() || user.username();
}
flarum.reg.add('champis-species', 'forum/utils/authorDisplayName', authorDisplayName);